export const name = 'gzSortDialogController';
export default function gzSortDialogController(
  sortModel,
  columns,
  $mdDialog,
  $gzAnalytics,
  pairingId
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;
  vm.columns = columns;

  vm.availableColumns = [];
  vm.sortDirection = "desc";
  vm.moveUpDisabled = moveUpDisabled;
  vm.moveDownDisabled = moveDownDisabled;
  vm.sortClicked = sortClicked;
  vm.moveUp = moveUp;
  vm.moveDown = moveDown;
  vm.toggleSortOrder = toggleSortOrder;
  vm.toggleSortDirection = toggleSortDirection;
  vm.addSort = addSort;
  vm.removeSort = removeSort;
  vm.submit = submit;
  vm.sort = [];

  activate();

  //////////////////

  function activate() {
    _.forEach(columns, column => {
      let allowSort = _.get(column, 'options.allowSort', true);
      if (allowSort) {
        vm.availableColumns.push(column);
      }
    });

    _.forEach(sortModel, sortItem => {
      let column = _.find(columns, {id: sortItem.colId});
      _.remove(vm.availableColumns, {id: sortItem.colId});

      let found = _.find(columns, {type: 'image'});
      if(found){
        _.remove(vm.availableColumns, {id: found.id});
      }

      let item = {
        id: column.id,
        column: column,
        sort: sortItem.sort
      };

      vm.sort.push(item);
    });

    if (vm.availableColumns.length > 0) {
      vm.availableColumns = _.sortBy(vm.availableColumns, column => {
        return column.header.title;
      });
      vm.sortColumn = vm.availableColumns[0];
    }
  }

  function submit() {
    let sortModel = [];
    _.forEach(vm.sort, sortItem => {
      let sort = {
        colId: sortItem.id,
        sort: sortItem.sort
      };
      sortModel.push(sort);
    });

    let columnIds = _.map(sortModel, 'colId');
    $gzAnalytics.eventSave(`Grid (${pairingId}) - Sorted column`, { label: `Sort: ${JSON.stringify(sortModel)}` });
    $mdDialog.hide(sortModel);
  }

  function sortClicked(sortItem) {
    if (vm.selected && vm.selected.id === sortItem.id) {
      delete vm.selected;
    }
    else {
      vm.selected = sortItem;
    }
  }

  function moveUpDisabled() {
    if (!vm.selected) {
      return true;
    }

    return vm.sort.indexOf(vm.selected) === 0;
  }

  function moveDownDisabled() {
    if (!vm.selected) {
      return true;
    }

    return vm.sort.indexOf(vm.selected) === vm.sort.length - 1;
  }

  function moveUp(event) {
    event.stopPropagation();
    let index = vm.sort.indexOf(vm.selected);
    if (index > 0) {
      _.remove(vm.sort, vm.selected);
      vm.sort.splice(index - 1, 0, vm.selected);
    }
  }

  function moveDown(event) {
    event.stopPropagation();
    let index = vm.sort.indexOf(vm.selected);
    if (index < vm.sort.length - 1) {
      _.remove(vm.sort, vm.selected);
      vm.sort.splice(index+1, 0, vm.selected);
    }
  }

  function toggleSortOrder(event, sortItem) {
    event.stopPropagation();
    if (sortItem.sort === "asc") {
      sortItem.sort = "desc";
    }
    else {
      sortItem.sort = "asc";
    }
  }

  function toggleSortDirection() {
    if (vm.sortDirection === "asc") {
      vm.sortDirection = "desc";
    }
    else {
      vm.sortDirection = "asc";
    }
  }

  function addSort() {
    let sortItem = {
      id: vm.sortColumn.id,
      column: vm.sortColumn,
      sort: vm.sortDirection
    };

    vm.sort.push(sortItem);
    vm.selected = sortItem;
    _.remove(vm.availableColumns, {id: sortItem.id});

    if (vm.availableColumns.length > 0) {
      vm.sortColumn = vm.availableColumns[0];
    }
  }

  function removeSort(event) {
    let index = vm.sort.indexOf(vm.selected);
    _.remove(vm.sort, {id: vm.selected.id});

    let found = _.find(columns, {id: vm.selected.id});
    if (found) {
      vm.availableColumns.push(found);
      vm.availableColumns = _.sortBy(vm.availableColumns, column => {
        return column.header.title;
      });
    }

    if (vm.sort.length === 0) {
      vm.selected = undefined;
    }
    else if (index > vm.sort.length -1) {
      vm.selected = vm.sort[vm.sort.length - 1];
    }
    else {
      vm.selected = vm.sort[index];
    }
  }
}
